import "core-js/modules/web.dom-collections.for-each.js";
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock, mergeProps as _mergeProps } from "vue";
const _hoisted_1 = {
  class: "dispatch-config"
};
const _hoisted_2 = {
  key: 0,
  class: "container"
};
const _hoisted_3 = {
  class: "header"
};

const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", {
  class: "title"
}, "设置团队配送规则", -1);

const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", {
  class: "sub-info"
}, "开启后，起送和邮费按照团队设置计算", -1);

const _hoisted_6 = {
  class: "delivery-config-wrapper"
};
const _hoisted_7 = {
  class: "delivery-config-main"
};
const _hoisted_8 = {
  key: 0,
  class: "wyc-delivery-fee-tips"
};
const _hoisted_9 = {
  key: 0,
  class: "wyc-delivery-fee-card"
};

const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", {
  class: "wyc-delivery-fee-title"
}, [/*#__PURE__*/_createTextVNode(" 以下商业公司已为您团队创建其\""), /*#__PURE__*/_createElementVNode("strong", null, "邮费设置"), /*#__PURE__*/_createTextVNode("\"规则，其订单不以您配置生效，请知晓 ")], -1);

const _hoisted_11 = {
  key: 0,
  class: "wyc-delivery-fee-list"
};
const _hoisted_12 = {
  key: 1,
  class: "wyc-delivery-fee-empty"
};
const _hoisted_13 = {
  key: 1,
  class: "wyc-delivery-fee-card"
};

const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", {
  class: "wyc-delivery-fee-title"
}, [/*#__PURE__*/_createTextVNode(" 以下商业公司已为您团队创建其\""), /*#__PURE__*/_createElementVNode("strong", null, "运输保险"), /*#__PURE__*/_createTextVNode("\"规则，其订单不以您配置生效，请知晓 ")], -1);

const _hoisted_15 = {
  key: 0,
  class: "wyc-delivery-fee-list"
};
const _hoisted_16 = {
  key: 1,
  class: "wyc-delivery-fee-empty"
};

const _hoisted_17 = /*#__PURE__*/_createTextVNode("0元起送");

const _hoisted_18 = /*#__PURE__*/_createTextVNode("满");

const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", null, "元起送", -1);

const _hoisted_20 = /*#__PURE__*/_createTextVNode("免配送费");

const _hoisted_21 = /*#__PURE__*/_createTextVNode("邮费（固定）");

const _hoisted_22 = {
  key: 0
};

const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", null, "元配送费", -1);

const _hoisted_24 = {
  class: "flex-wrapper"
};

const _hoisted_25 = /*#__PURE__*/_createTextVNode("邮费（满额包邮）");

const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", null, "不满", -1);

const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", null, "元包邮门槛，需要额外支付", -1);

const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", null, "元配送费；", -1);

const _hoisted_29 = {
  style: {
    "margin-left": "20px"
  }
};

const _hoisted_30 = /*#__PURE__*/_createElementVNode("span", {
  class: "red"
}, "设置：优惠后配送费", -1);

const _hoisted_31 = /*#__PURE__*/_createElementVNode("span", {
  class: "red"
}, "元", -1);

const _hoisted_32 = {
  class: "flex-wrapper"
};

const _hoisted_33 = /*#__PURE__*/_createTextVNode("邮费（满额包邮-有优惠）");

const _hoisted_34 = {
  key: 0
};

const _hoisted_35 = /*#__PURE__*/_createElementVNode("span", null, "不满", -1);

const _hoisted_36 = /*#__PURE__*/_createElementVNode("span", null, "元包邮门槛，需要额外支付", -1);

const _hoisted_37 = /*#__PURE__*/_createElementVNode("span", null, "元配送费；", -1);

const _hoisted_38 = /*#__PURE__*/_createTextVNode("不支持购买");

const _hoisted_39 = /*#__PURE__*/_createTextVNode("支持购买(无最低保费)");

const _hoisted_40 = /*#__PURE__*/_createTextVNode("支持购买(有最低保费)");

const _hoisted_41 = {
  key: 0,
  style: {
    "margin-top": "8px"
  }
};
const _hoisted_42 = {
  key: 1,
  style: {
    "margin-top": "8px",
    "display": "flex",
    "align-items": "center"
  }
};

const _hoisted_43 = /*#__PURE__*/_createElementVNode("span", null, "最低购买", -1);

const _hoisted_44 = /*#__PURE__*/_createTextVNode("保存");

const _hoisted_45 = {
  key: 1,
  class: "container"
};
const _hoisted_46 = {
  class: "header"
};

const _hoisted_47 = /*#__PURE__*/_createElementVNode("span", {
  class: "title"
}, "业务员选择“随货通行单金额”", -1);

const _hoisted_48 = /*#__PURE__*/_createElementVNode("span", {
  class: "sub-info"
}, "开启后业务员可选择下发商业的商品金额为销售价或预付价", -1);

const _hoisted_49 = {
  class: "container",
  style: {
    "display": "none"
  }
};

const _hoisted_50 = /*#__PURE__*/_createElementVNode("div", {
  class: "header"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "title"
}, "货主库存")], -1);

const _hoisted_51 = /*#__PURE__*/_createTextVNode("保存");

const _hoisted_52 = {
  key: 2
};

const _hoisted_53 = /*#__PURE__*/_createTextVNode(" 新增 ");

const _hoisted_54 = /*#__PURE__*/_createTextVNode(" 删除 ");

const _hoisted_55 = {
  key: 3,
  class: "container"
};
const _hoisted_56 = {
  class: "header"
};

const _hoisted_57 = /*#__PURE__*/_createElementVNode("span", {
  class: "title"
}, "统仓统配服务", -1);

const _hoisted_58 = {
  key: 4,
  class: "container"
};
const _hoisted_59 = {
  class: "header"
};

const _hoisted_60 = /*#__PURE__*/_createElementVNode("span", {
  class: "title"
}, "是否支持线下结算", -1);

const _hoisted_61 = {
  key: 5,
  class: "container"
};
const _hoisted_62 = {
  class: "header"
};

const _hoisted_63 = /*#__PURE__*/_createElementVNode("span", {
  class: "title"
}, "是否支持挂账结算", -1);

const _hoisted_64 = {
  key: 6,
  class: "container"
};
const _hoisted_65 = {
  class: "header"
};

const _hoisted_66 = /*#__PURE__*/_createElementVNode("span", {
  class: "title"
}, "取消订单权限", -1);

const _hoisted_67 = /*#__PURE__*/_createElementVNode("span", {
  class: "sub-info"
}, "开启后，审核通过订单可进行取消", -1);

const _hoisted_68 = /*#__PURE__*/_createElementVNode("div", {
  style: {
    "padding": "0 20px 20px 20px",
    "color": "red"
  }
}, "注意：取消订单仅为校准万药通数据，若与发货方系统直连，需线下与发货方联系沟通取消信息。", -1);

const _hoisted_69 = {
  key: 7,
  class: "container"
};
const _hoisted_70 = {
  class: "header"
};

const _hoisted_71 = /*#__PURE__*/_createElementVNode("span", {
  class: "title"
}, "万药通学堂模块展示", -1);

const _hoisted_72 = {
  class: "container"
};
const _hoisted_73 = {
  class: "header"
};

const _hoisted_74 = /*#__PURE__*/_createElementVNode("span", {
  class: "title"
}, "逾期客户下单权限", -1);

const _hoisted_75 = /*#__PURE__*/_createElementVNode("span", {
  class: "sub-info"
}, "开启后，逾期客户不可下单；仅客户为团队垫资结算时逾期可下单拦截", -1);

const _hoisted_76 = /*#__PURE__*/_createElementVNode("div", {
  style: {
    "padding": "0 20px 20px 20px",
    "color": "red"
  }
}, "注意：仅客户为团队垫资结算时逾期可下单拦截。", -1);

const _hoisted_77 = {
  class: "container"
};

const _hoisted_78 = /*#__PURE__*/_createElementVNode("div", {
  class: "header"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "title"
}, "物流查询调用方式")], -1);

const _hoisted_79 = {
  style: {
    "padding": "0 20px 20px 20px"
  }
};

const _hoisted_80 = /*#__PURE__*/_createTextVNode("快递100（免费-每日限2次）");

const _hoisted_81 = /*#__PURE__*/_createTextVNode("快递鸟（付费-不限制查询次数）");

const _hoisted_82 = {
  key: 8,
  class: "container"
};
const _hoisted_83 = {
  class: "header"
};

const _hoisted_84 = /*#__PURE__*/_createElementVNode("span", {
  class: "title"
}, "货到付款权限", -1);

const _hoisted_85 = /*#__PURE__*/_createElementVNode("span", {
  class: "sub-info"
}, "开启后，团队订单支付方式可选货到付款", -1);

const _hoisted_86 = /*#__PURE__*/_createElementVNode("div", {
  style: {
    "padding": "0 20px 20px 20px",
    "color": "red"
  }
}, "业务员选择货到付款后，订单已签收或已完成则通知业务员向客户催收。", -1);

const _hoisted_87 = {
  class: "container"
};
const _hoisted_88 = {
  class: "header"
};

const _hoisted_89 = /*#__PURE__*/_createElementVNode("span", {
  class: "title"
}, "支付金额支持预付", -1);

const _hoisted_90 = /*#__PURE__*/_createElementVNode("span", {
  class: "sub-info"
}, "预付金额=业务员所属团队层级的商品进货价*数量", -1);

const _hoisted_91 = /*#__PURE__*/_createElementVNode("div", {
  style: {
    "padding": "0 20px 20px 20px",
    "color": "red"
  }
}, "提交订单时存在团队层级未设置团队进货价，即此单不支持预付，不展示其预付金额选项", -1);

const _hoisted_92 = /*#__PURE__*/_createElementVNode("div", {
  style: {
    "padding": "0 20px 20px 20px",
    "color": "red"
  }
}, "注意：该开关仅对此层级团队业务员生效", -1);

import { ref, reactive, onMounted, nextTick, computed, watch } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import { getSupplierDeliveryConfig, saveSupplierDeleveryConfig, saveSupplierInvoiceConfig, saveSupplierOwnerConfig, searchBranchOwnerInfoList, searchSupplierOwnerInfoList, saveCancerOrderConfig, saveDynamicBusinessMenuStatus, saveCustOrderCheck } from '@/request';
import Axios from '@/request/createAxiosInstalce';
import { ElMessage } from 'element-plus';
import { getVexTableProps } from '@/config';
import PanelWrapper from '@/components/PanelWrapper.vue';
import AddSupplierOwnerModal from './AddSupplierOwnerModal.vue';
export default {
  name: 'DispatchConfig',
  props: {
    actDept: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ['setStorageType'],

  setup(__props, {
    emit: emits
  }) {
    const props = __props; // onMounted(() => getConfig());

    const storeVuex = useStore();
    const userType = computed(() => storeVuex.state.user.userType);
    const basicShow = computed(() => props.actDept.levelType == '0');
    const route = useRoute();
    const configOpen = ref(0);
    const deliveryStartType = ref(1);
    const deliveryType = ref(1);
    const chooseKpType = ref(0);
    const wycDeliveryFeeLoading = ref(false);
    const wycPostageFeeConfigured = ref(false);
    const wycTransitInsuranceConfigured = ref(false);
    const wycPostageStoreNames = ref([]);
    const wycTransitInsuranceStoreNames = ref([]);
    const deliveryConfigInfo = reactive({
      supplierDeliveryConfigId: undefined,
      // 配置ID，有就是更新，无就是保存
      orderStartState: 2,
      // 起送金额配置(0-不限制,1-每天第一笔拦截,2-每笔拦截)起送金额配置(0-不限制,1-每天第一笔拦截,2-每笔拦截)
      orderStartMoney: undefined,
      // 起送金额，保留2位小数，最大值99999.99
      freePostage: 1,
      // 是否免邮费，0：不免邮费 1：免邮费
      freePostageOrderMoney: undefined,
      // 订单免邮金额，保留2位小数，最大值99999.99
      preferentialPostage: undefined,
      // 订单邮费(优惠价)
      postage: undefined,
      // 订单邮费(小于等于0时处理成免邮)
      deliveryInsuranceStatus: 0,
      // 保险状态，0/1/2
      noMinPremiumDesc: '',
      // 无最低保费说明
      hasMinPremiumDesc: '',
      // 有最低保费说明
      minPremiumAmount: undefined // 有最低保费的最低金额

    });
    const loading = ref(true);

    function normalizeStoreNameList(list) {
      if (!Array.isArray(list)) {
        return [];
      }

      return list.map(item => {
        if (typeof item === 'string' || typeof item === 'number') return String(item);
        return (item === null || item === void 0 ? void 0 : item.branchName) || (item === null || item === void 0 ? void 0 : item.companyName) || (item === null || item === void 0 ? void 0 : item.name) || (item === null || item === void 0 ? void 0 : item.branchFullName) || '';
      }).filter(Boolean);
    }

    function resetWycDeliveryFeeTips() {
      wycPostageFeeConfigured.value = false;
      wycTransitInsuranceConfigured.value = false;
      wycPostageStoreNames.value = [];
      wycTransitInsuranceStoreNames.value = [];
    }

    function getWycProjectDeliveryFeeConfig() {
      wycDeliveryFeeLoading.value = true;
      const params = {
        supplierId: route.query.supplierId
      };
      return Axios.get('/admin/supplierConfig/getWycProjectDeliveryFeeConfig.json', {
        params
      }).then(res => {
        const result = res === null || res === void 0 ? void 0 : res.data;
        const tipData = result !== null && result !== void 0 && result.data && typeof result.data === 'object' && !Array.isArray(result.data) ? result.data : null;

        if (result !== null && result !== void 0 && result.success && tipData) {
          const postageNames = normalizeStoreNameList(tipData.postageStoreNames || tipData.postage_store_names);
          const insuranceNames = normalizeStoreNameList(tipData.transitInsuranceStoreNames || tipData.transit_insurance_store_names);
          wycPostageStoreNames.value = postageNames;
          wycTransitInsuranceStoreNames.value = insuranceNames;
          wycPostageFeeConfigured.value = postageNames.length > 0;
          wycTransitInsuranceConfigured.value = insuranceNames.length > 0;
          return wycPostageFeeConfigured.value || wycTransitInsuranceConfigured.value;
        } // 兼容旧版：data 仍是商业公司名称数组


        if (result !== null && result !== void 0 && result.success && Array.isArray(result.data)) {
          const names = normalizeStoreNameList(result.data);
          wycPostageStoreNames.value = names;
          wycTransitInsuranceStoreNames.value = [];
          wycPostageFeeConfigured.value = names.length > 0;
          wycTransitInsuranceConfigured.value = false;
          return names.length > 0;
        }

        resetWycDeliveryFeeTips();
        return false;
      }).catch(() => {
        resetWycDeliveryFeeTips();
        return false;
      }).finally(() => {
        wycDeliveryFeeLoading.value = false;
      });
    }

    function getConfig() {
      loading.value = true;
      let params = {
        supplierId: route.query.supplierId
      };

      if (!basicShow.value) {
        params.structureId = props.actDept.id;
      }

      getSupplierDeliveryConfig(params).then(res => {
        let {
          supplierDeliveryStatus,
          deliveryConfigInfoVo,
          branchOwnerInfoVos,
          storageShowType
        } = res.data;
        configOpen.value = supplierDeliveryStatus;

        if (supplierDeliveryStatus) {
          getWycProjectDeliveryFeeConfig();
        } else {
          resetWycDeliveryFeeTips();
        }

        chooseKpType.value = res.data.chooseKpType;
        orderCancelStatus.value = res.data.orderCancelStatus;
        dynamicBusinessMenuStatus.value = res.data.dynamicBusinessMenuStatus;
        overdueCustOrderCheck.value = res.data.overdueCustOrderCheck;
        logisticsQueryType.value = res.data.logisticsQueryType;
        cashOnDeliveryStatus.value = res.data.cashOnDeliveryStatus;
        unifiedWarehouseStatus.value = res.data.unifiedWarehouseStatus;
        offlineSettlement.value = res.data.offlineSettlement;
        creditSettlement.value = res.data.creditSettlement; // 获取预付开关状态

        prePaymentSwitch.value = res.data.prePaymentSwitch || 0;
        branchList.value = branchOwnerInfoVos.map(item => {
          item.value = `${item.ownerId}-${item.branchId}`;
          return item;
        });
        branchStorageData.branchOwnerInfoVos = branchOwnerInfoVos;
        branchStorageData.storageShowType = storageShowType == null ? 0 : storageShowType;

        if (deliveryConfigInfoVo) {
          Object.keys(deliveryConfigInfoVo).forEach(key => {
            deliveryConfigInfo[key] = deliveryConfigInfoVo[key];
          }); // 起送金额选项

          deliveryConfigInfo.orderStartMoney && (deliveryStartType.value = 2); // 邮费选项

          if (deliveryConfigInfo.freePostage) {
            deliveryType.value = 1;
          } else if (deliveryConfigInfo.hasFixPostage) {
            deliveryType.value = 4;
          } else {
            deliveryConfigInfo.preferentialPostage ? deliveryType.value = 2 : deliveryType.value = 3;
          }

          deliveryConfigInfoVo.deliveryInsuranceStatus = deliveryConfigInfo.deliveryInsuranceStatus;
          deliveryConfigInfoVo.noMinPremiumDesc = deliveryConfigInfo.noMinPremiumDesc;
          deliveryConfigInfoVo.hasMinPremiumDesc = deliveryConfigInfo.hasMinPremiumDesc;
          deliveryConfigInfoVo.minPremiumAmount = deliveryConfigInfo.minPremiumAmount;
        } // 如果团队绑定了货主而且库存模式为团队库位库存时，库存text为库位库存


        if (branchOwnerInfoVos.length && storageShowType === 0) {
          emits('setStorageType', 1);
        }

        loading.value = false;
      });
    }

    const showAddOwnerModal = ref(false);
    const tablePage = {
      pageSizes: [10, 50, 100, 200]
    };
    const ownerTable = ref(null);
    let ownerTableOptions = getVexTableProps({
      columns: [{
        title: '货位号',
        field: 'ownerId',
        width: '150px',
        showOverflow: true
      }, {
        title: '货位名称',
        field: 'ownerName',
        width: '120px',
        showOverflow: true
      }, {
        title: '所属仓库',
        field: 'wareHouseName',
        width: '100px',
        showOverflow: true
      }, {
        title: '商业',
        field: 'branchName',
        width: '200px',
        showOverflow: true
      }, {
        title: '默认',
        width: '100px',
        field: 'isDefault',
        showOverflow: true,
        type: 'checkbox'
      }, {
        title: '操作',
        width: '100px',
        field: 'operation',
        fixed: 'right',
        slots: {
          default: 'operation'
        }
      }],
      toolbarConfig: {
        slots: {
          buttons: 'tools'
        }
      },
      proxyConfig: {
        ajax: {
          query: ({
            page
          }) => new Promise(res => {
            let params = {
              supplierId: route.query.supplierId,
              page: page.currentPage,
              pageSize: page.pageSize
            };

            if (!basicShow.value) {
              params.structureId = props.actDept.id;
            }

            searchSupplierOwnerInfoList(params).then(data => {
              res({
                total: data.total,
                result: data.rows
              });
              let selectedRows = data.rows.filter(item => item.isDefault === 1);
              ownerTable.value.setCheckboxRow(selectedRows, true);
            });
          })
        }
      }
    });
    watch(() => props.actDept.id, () => getConfig());

    function _validate() {
      let flag = true;
      if (configOpen.value === 0) return flag;

      if (deliveryStartType.value === 2) {
        // 满xx元起送
        if (Boolean(deliveryConfigInfo.orderStartMoney) === false) {
          flag = false;
          ElMessage.error('起送门槛设置需要大于0元');
        }
      }

      if (deliveryType.value === 2) {
        // 有邮费（有优惠）
        if (Boolean(deliveryConfigInfo.freePostageOrderMoney) === false || Boolean(deliveryConfigInfo.postage) === false || Boolean(deliveryConfigInfo.preferentialPostage) === false) {
          flag = false;
          ElMessage.error('邮费设置需要大于0');
        }
      }

      if (deliveryType.value === 3) {
        // 有邮费（无优惠）
        if (Boolean(deliveryConfigInfo.freePostageOrderMoney) === false || Boolean(deliveryConfigInfo.postage) === false) {
          flag = false;
          ElMessage.error('邮费设置需要大于0');
        }
      }

      if (deliveryType.value === 4) {
        // 有邮费（固定邮费）
        if (Boolean(deliveryConfigInfo.postage) === false) {
          flag = false;
          ElMessage.error('固定邮费设置需要大于0');
        }
      } // 运输保险校验


      if (deliveryConfigInfo.deliveryInsuranceStatus === 1) {
        if (!deliveryConfigInfo.noMinPremiumDesc) {
          flag = false;
          ElMessage.error('请填写无最低保费的保额说明');
        }
      }

      if (deliveryConfigInfo.deliveryInsuranceStatus === 2) {
        if (!deliveryConfigInfo.hasMinPremiumDesc) {
          flag = false;
          ElMessage.error('请填写有最低保费的保额说明');
        }

        if (deliveryConfigInfo.minPremiumAmount === undefined || deliveryConfigInfo.minPremiumAmount === null || Number(deliveryConfigInfo.minPremiumAmount) <= 0) {
          flag = false;
          ElMessage.error('最低保费金额必须大于0');
        }
      }

      return flag;
    }

    function save(saveType) {
      if (_validate() === false) return undefined;
      let body = {
        supplierId: route.query.supplierId,
        supplierDeliveryStatus: configOpen.value
      };

      if (configOpen.value) {
        let deliveryConfigInfoVo = {};
        deliveryConfigInfoVo.supplierDeliveryConfigId = deliveryConfigInfo.supplierDeliveryConfigId;
        deliveryConfigInfoVo.orderStartState = deliveryConfigInfo.orderStartState;

        if (deliveryStartType.value === 2 && deliveryConfigInfo.orderStartMoney > 0) {
          // 有起送门槛
          deliveryConfigInfoVo.orderStartMoney = deliveryConfigInfo.orderStartMoney;
          deliveryConfigInfoVo.orderStartState = 2;
        } else {
          deliveryConfigInfoVo.orderStartState = 0;
          deliveryConfigInfoVo.orderStartMoney = 0;
        }

        switch (deliveryType.value) {
          case 1:
            // 免邮
            deliveryConfigInfoVo.freePostage = 1;
            deliveryConfigInfoVo.hasFixPostage = 0;
            break;

          case 2:
            // 邮费(有优惠)
            deliveryConfigInfoVo.freePostage = 0;
            deliveryConfigInfoVo.hasFixPostage = 0;
            deliveryConfigInfoVo.freePostageOrderMoney = deliveryConfigInfo.freePostageOrderMoney;
            deliveryConfigInfoVo.postage = deliveryConfigInfo.postage;
            deliveryConfigInfoVo.preferentialPostage = deliveryConfigInfo.preferentialPostage;
            break;

          case 3:
            // 邮费(无优惠)
            deliveryConfigInfoVo.freePostage = 0;
            deliveryConfigInfoVo.hasFixPostage = 0;
            deliveryConfigInfoVo.freePostageOrderMoney = deliveryConfigInfo.freePostageOrderMoney;
            deliveryConfigInfoVo.postage = deliveryConfigInfo.postage;
            break;

          case 4:
            // 邮费(固定)
            deliveryConfigInfoVo.freePostage = 0;
            deliveryConfigInfoVo.hasFixPostage = 1;
            deliveryConfigInfoVo.postage = deliveryConfigInfo.postage;

          default:
            break;
        }

        deliveryConfigInfoVo.deliveryInsuranceStatus = deliveryConfigInfo.deliveryInsuranceStatus;
        deliveryConfigInfoVo.noMinPremiumDesc = deliveryConfigInfo.noMinPremiumDesc;
        deliveryConfigInfoVo.hasMinPremiumDesc = deliveryConfigInfo.hasMinPremiumDesc;
        deliveryConfigInfoVo.minPremiumAmount = deliveryConfigInfo.deliveryInsuranceStatus === 2 ? deliveryConfigInfo.minPremiumAmount : 0;
        body.deliveryConfigInfoVo = deliveryConfigInfoVo;
      }

      return saveSupplierDeleveryConfig(body).then(res => {
        let {
          success,
          msg
        } = res;

        if (saveType === 'saveSwitch') {
          return success;
        }

        if (success) {
          ElMessage.success(msg);
        } else {
          ElMessage.error(msg);
        }
      });
    }

    function switchHandle(flag) {
      const request = flag ? getWycProjectDeliveryFeeConfig() : Promise.resolve(false);
      request.finally(() => {
        save('saveSwitch').then(success => {
          let message = '';

          if (flag) {
            // 开启
            message = success ? '开启成功' : '开启失败';
          } else {
            message = success ? '关闭成功' : '关闭失败';
          }

          if (success) {
            getConfig();
            ElMessage.success(message);
          } else {
            // 开关保存失败时回滚UI状态
            configOpen.value = flag ? 0 : 1;
            ElMessage.error(message);
          }
        });
      });
    } // 开票方式开关


    function chooseKpTypeSwitchHandle() {
      let body = {
        supplierId: route.query.supplierId,
        chooseKpType: chooseKpType.value
      };
      saveSupplierInvoiceConfig(body).then(res => {
        let {
          success,
          msg
        } = res;

        if (success) {
          ElMessage.success(msg);
        } else {
          ElMessage.error(msg);
        }
      });
    } // 多货主库存


    const branchStorageData = reactive({
      branchOwnerInfoVos: [],
      // 关联货主model
      storageShowType: 0 // app库存展示类型，0：团队库存库位，1：商业公司库存

    });
    const selectLoading = ref(false);
    const branchList = ref([]);

    function branchStorageSearchHandle(keyWord) {
      selectLoading.value = true;
      let params = {
        supplierId: route.query.supplierId,
        keyWord
      };
      searchBranchOwnerInfoList(params).then(res => {
        branchList.value = res.data;
        selectLoading.value = false;
      });
    }

    function branchStorageSaveHandle() {
      let branchOwnerInfoVos = branchStorageData.branchOwnerInfoVos;
      let body = {
        supplierId: route.query.supplierId,
        branchOwnerInfoVos
      };

      if (!basicShow.value) {
        body.structureId = props.actDept.id;
      }

      saveSupplierOwnerConfig(body).then(res => {
        let {
          success,
          msg
        } = res;

        if (success) {
          ElMessage.success(msg);
        } else {
          ElMessage.error(msg);
        }
      });
    }

    function branchChangeHandle(valueList) {
      // console.log('valueList', valueList)
      // return
      if (valueList.length === 0) return false;
      let selectedList = branchStorageData.branchOwnerInfoVos;

      if (selectedList.length === 0) {
        branchStorageData.branchOwnerInfoVos = valueList;
        return true;
      }

      if (selectedList.length > valueList.length) {
        return true;
      } // 同商业公司只能选一个货主，


      let targetValue = valueList[valueList.length - 1];
      let targetWardId = targetValue.branchId;
      let someWareIndex = selectedList.findIndex(value => {
        return value.branchId === targetWardId;
      });

      if (someWareIndex > -1) {
        selectedList.splice(someWareIndex, 1);
        selectedList.push(targetValue);
      } else {
        branchStorageData.branchOwnerInfoVos = valueList;
      }
    }

    function branchRemoveHandle(removeValue) {
      let selectedList = branchStorageData.branchOwnerInfoVos;
      let removeIndex = selectedList.findIndex(v => v.ownerId === removeValue.ownerId);
      selectedList.splice(removeIndex, 1);
    }

    function getOwnerName(item) {
      let {
        ownerId = '',
        ownerName = '',
        wareHouseName = '',
        branchName = ''
      } = item;

      if (wareHouseName) {
        return `${ownerName}(${ownerId})-${wareHouseName}-${branchName}`;
      }

      return `${ownerName}(${ownerId})-${branchName}`;
    } // 取消订单开关


    const orderCancelStatus = ref(0);

    function orderCancelStatusSwitchHandle() {
      let body = {
        supplierId: route.query.supplierId,
        orderCancelStatus: orderCancelStatus.value
      }; // console.log(body)

      saveCancerOrderConfig(body).then(res => {
        let {
          success,
          msg
        } = res;

        if (success) {
          ElMessage.success(msg);
        } else {
          orderCancelStatus.value = 0;
          ElMessage.error(msg);
        }
      });
    } // 动态商机开关


    const dynamicBusinessMenuStatus = ref(0);

    function dynamicBusinessMenuStatusSwitchHandle() {
      let body = {
        supplierId: route.query.supplierId,
        dynamicBusinessMenuStatus: dynamicBusinessMenuStatus.value
      };
      saveDynamicBusinessMenuStatus(body).then(res => {
        let {
          success,
          msg
        } = res;

        if (success) {
          ElMessage.success(msg);
        } else {
          ElMessage.error(msg);
        }
      });
    } // 逾期客户下单拦截配置


    const overdueCustOrderCheck = ref(0);

    function overdueCustOrderCheckSwitchHandle() {
      let body = {
        supplierId: route.query.supplierId,
        overdueCustOrderCheck: overdueCustOrderCheck.value
      };
      saveCustOrderCheck(body).then(res => {
        let {
          success,
          msg
        } = res;

        if (success) {
          ElMessage.success(msg);
        } else {
          ElMessage.error(msg);
        }
      });
    } // 快读调用方式


    const logisticsQueryType = ref(0);

    function saveLogisticsQueryType() {
      let body = {
        supplierId: route.query.supplierId,
        logisticsQueryType: logisticsQueryType.value
      };
      Axios.post('/admin/supplierConfig/saveSupplierLogisticsQueryType.json', body).then(res => {
        let {
          success,
          msg
        } = res.data;

        if (success) {
          ElMessage.success(msg);
        } else {
          ElMessage.error(msg);
        }
      });
    } // 货到付款权限配置


    const cashOnDeliveryStatus = ref(0);

    function cashDeliveryHandle() {
      let body = {
        supplierId: route.query.supplierId,
        cashOnDeliveryStatus: cashOnDeliveryStatus.value
      };
      Axios.post('/admin/supplierConfig/saveSupplierCashOnDeliveryStatus.json', body).then(res => {
        let {
          success,
          msg
        } = res.data;

        if (success) {
          ElMessage.success(msg);
        } else {
          ElMessage.error(msg);
        }
      });
    } // 统仓统配服务


    const unifiedWarehouseStatus = ref(0);

    function saveUnifiedWarehouseStatus() {
      let body = {
        supplierId: route.query.supplierId,
        unifiedWarehouseStatus: unifiedWarehouseStatus.value
      };
      Axios.post('/admin/supplierConfig/saveSupplierUnifiedWarehouseStatus.json', body).then(res => {
        let {
          success,
          msg
        } = res.data;

        if (success) {
          ElMessage.success(msg);
        } else {
          ElMessage.error(msg);
        }
      });
    } // 线下结算开关


    const offlineSettlement = ref(0);

    function saveOfflineSettlement() {
      let body = {
        supplierId: route.query.supplierId,
        offlineSettlement: offlineSettlement.value
      };
      Axios.post('/admin/supplierConfig/saveSupplierOfflineSettlement.json', body).then(res => {
        let {
          success,
          msg
        } = res.data;

        if (success) {
          ElMessage.success(msg);
        } else {
          ElMessage.error(msg);
        }
      });
    } // 挂账结算开关


    const creditSettlement = ref(0);

    function saveCreditSettlement() {
      let body = {
        supplierId: route.query.supplierId,
        creditSettlement: creditSettlement.value
      };
      Axios.post('/admin/supplierConfig/saveSupplierCreditSettlement.json', body).then(res => {
        let {
          success,
          msg
        } = res.data;

        if (success) {
          ElMessage.success(msg);
        } else {
          ElMessage.error(msg);
        }
      });
    } // 预付金额支付开关


    const prePaymentSwitch = ref(0);

    function prePaymentSwitchHandle() {
      var _props$actDept;

      // 构建请求体
      let body = {
        supplierId: route.query.supplierId,
        prePaymentSwitch: prePaymentSwitch.value
      }; // 如果不是根团队（levelType !== '0'），则需要传递 structureId

      if (((_props$actDept = props.actDept) === null || _props$actDept === void 0 ? void 0 : _props$actDept.levelType) !== '0') {
        body.structureId = props.actDept.id;
      } // 发送请求


      Axios.post('/admin/supplierConfig/savePrepaySwitch.json', body).then(res => {
        let {
          success,
          msg
        } = res.data;

        if (success) {
          ElMessage.success(msg);
        } else {
          ElMessage.error(msg);
        }
      });
    }

    function handleCheckboxChange({
      row,
      checked
    }) {
      var _props$actDept2;

      console.log('Row changed:', row, 'Checked:', checked); // 在这里处理选中或取消选中后的逻辑，例如更新其他数据或发送请求等。

      let isDefault = 0;
      let supplierOwnerId = row.supplierOwnerId;

      if (checked) {
        isDefault = 1;
      } // 构建请求体


      let body = {
        branchId: row.branchId,
        supplierId: route.query.supplierId,
        supplierOwnerId: supplierOwnerId,
        isDefault: isDefault
      }; // 如果不是根团队（levelType !== '0'），则需要传递 structureId

      if (((_props$actDept2 = props.actDept) === null || _props$actDept2 === void 0 ? void 0 : _props$actDept2.levelType) !== '0') {
        body.structureId = props.actDept.id;
      } // 发送请求


      Axios.post('/admin/supplierConfig/saveSupplierOwnerCheck.json', body).then(res => {
        let {
          success,
          msg
        } = res.data;

        if (success) {
          ElMessage.success(msg);
        } else {
          ElMessage.error(msg);
        }

        loadSupplierOwner();
      });
    }

    function handleAllCheckboxChange() {
      ElMessage.error("该功能不支持全选");
      return false;
    }

    function delOwnerRow(row) {
      let supplierOwnerId = row.supplierOwnerId;
      let body = {
        supplierOwnerId: supplierOwnerId
      }; // 发送请求

      Axios.post('/admin/supplierConfig/deleteSupplierOwner.json', body).then(res => {
        let {
          success,
          msg
        } = res.data;

        if (success) {
          ElMessage.success(msg);
        } else {
          ElMessage.error(msg);
        }

        loadSupplierOwner();
      });
    }

    function addOwnerModal() {
      showAddOwnerModal.value = true;
    }

    function loadSupplierOwner() {
      ownerTable.value.commitProxy('reload');
    }

    return (_ctx, _cache) => {
      const _component_el_switch = _resolveComponent("el-switch");

      const _component_el_radio = _resolveComponent("el-radio");

      const _component_el_input_number = _resolveComponent("el-input-number");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_radio_group = _resolveComponent("el-radio-group");

      const _component_el_input = _resolveComponent("el-input");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_vxe_grid = _resolveComponent("vxe-grid");

      const _directive_loading = _resolveDirective("loading");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_unref(basicShow) ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _hoisted_5, _createVNode(_component_el_switch, {
        modelValue: configOpen.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => configOpen.value = $event),
        "active-value": 1,
        "inactive-value": 0,
        onChange: switchHandle
      }, null, 8, ["modelValue"])]), configOpen.value ? (_openBlock(), _createBlock(_component_el_form, {
        key: 0
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [wycPostageFeeConfigured.value || wycTransitInsuranceConfigured.value ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_8, [wycPostageFeeConfigured.value ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_hoisted_10, wycPostageStoreNames.value.length ? (_openBlock(), _createElementBlock("div", _hoisted_11, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(wycPostageStoreNames.value, (item, index) => {
          return _openBlock(), _createElementBlock("div", {
            key: `postage-${item}-${index}`
          }, _toDisplayString(item), 1);
        }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_12, "已设置邮费规则，但未返回商业公司名称"))])) : _createCommentVNode("", true), wycTransitInsuranceConfigured.value ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_hoisted_14, wycTransitInsuranceStoreNames.value.length ? (_openBlock(), _createElementBlock("div", _hoisted_15, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(wycTransitInsuranceStoreNames.value, (item, index) => {
          return _openBlock(), _createElementBlock("div", {
            key: `insurance-${item}-${index}`
          }, _toDisplayString(item), 1);
        }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_16, "已设置运输保险规则，但未返回商业公司名称"))])) : _createCommentVNode("", true)])), [[_directive_loading, wycDeliveryFeeLoading.value]]) : _createCommentVNode("", true), _createVNode(_component_el_form_item, {
          label: "起送门槛"
        }, {
          default: _withCtx(() => [_createElementVNode("div", null, [_createVNode(_component_el_radio, {
            modelValue: deliveryStartType.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => deliveryStartType.value = $event),
            label: 1
          }, {
            default: _withCtx(() => [_hoisted_17]),
            _: 1
          }, 8, ["modelValue"])]), _createElementVNode("div", null, [_createVNode(_component_el_radio, {
            modelValue: deliveryStartType.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => deliveryStartType.value = $event),
            label: 2
          }, {
            default: _withCtx(() => [_hoisted_18]),
            _: 1
          }, 8, ["modelValue"]), _createVNode(_component_el_input_number, {
            modelValue: deliveryConfigInfo.orderStartMoney,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => deliveryConfigInfo.orderStartMoney = $event),
            min: 0,
            max: 99999.99,
            precision: 2,
            disabled: deliveryStartType.value !== 2
          }, null, 8, ["modelValue", "max", "disabled"]), _hoisted_19])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "邮费设置"
        }, {
          default: _withCtx(() => [_createElementVNode("div", null, [_createVNode(_component_el_radio, {
            modelValue: deliveryType.value,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => deliveryType.value = $event),
            label: 1
          }, {
            default: _withCtx(() => [_hoisted_20]),
            _: 1
          }, 8, ["modelValue"])]), _createElementVNode("div", null, [_createVNode(_component_el_radio, {
            modelValue: deliveryType.value,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => deliveryType.value = $event),
            label: 4
          }, {
            default: _withCtx(() => [_hoisted_21]),
            _: 1
          }, 8, ["modelValue"]), deliveryType.value === 4 ? (_openBlock(), _createElementBlock("div", _hoisted_22, [_createVNode(_component_el_input_number, {
            modelValue: deliveryConfigInfo.postage,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => deliveryConfigInfo.postage = $event),
            min: 0,
            max: 99999.99,
            precision: 2,
            class: "ml"
          }, null, 8, ["modelValue", "max"]), _hoisted_23])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_24, [_createVNode(_component_el_radio, {
            modelValue: deliveryType.value,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => deliveryType.value = $event),
            label: 2,
            style: {
              "margin-right": "0"
            }
          }, {
            default: _withCtx(() => [_hoisted_25]),
            _: 1
          }, 8, ["modelValue"]), deliveryType.value === 2 ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [_createElementVNode("div", null, [_hoisted_26, _createVNode(_component_el_input_number, {
            modelValue: deliveryConfigInfo.freePostageOrderMoney,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => deliveryConfigInfo.freePostageOrderMoney = $event),
            min: 0,
            max: 99999.99,
            precision: 2,
            class: "ml"
          }, null, 8, ["modelValue", "max"]), _hoisted_27, _createVNode(_component_el_input_number, {
            modelValue: deliveryConfigInfo.postage,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => deliveryConfigInfo.postage = $event),
            class: "ml",
            min: 0,
            max: 99999.99,
            precision: 2
          }, null, 8, ["modelValue", "max"]), _hoisted_28]), _createElementVNode("div", _hoisted_29, [_hoisted_30, _createVNode(_component_el_input_number, {
            modelValue: deliveryConfigInfo.preferentialPostage,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => deliveryConfigInfo.preferentialPostage = $event),
            min: 0,
            max: 99999.99,
            precision: 2,
            class: "ml"
          }, null, 8, ["modelValue", "max"]), _hoisted_31])], 64)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_32, [_createVNode(_component_el_radio, {
            modelValue: deliveryType.value,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => deliveryType.value = $event),
            label: 3,
            style: {
              "margin-right": "0"
            }
          }, {
            default: _withCtx(() => [_hoisted_33]),
            _: 1
          }, 8, ["modelValue"]), deliveryType.value === 3 ? (_openBlock(), _createElementBlock("div", _hoisted_34, [_hoisted_35, _createVNode(_component_el_input_number, {
            modelValue: deliveryConfigInfo.freePostageOrderMoney,
            "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => deliveryConfigInfo.freePostageOrderMoney = $event),
            min: 0,
            max: 99999.99,
            precision: 2,
            class: "ml"
          }, null, 8, ["modelValue", "max"]), _hoisted_36, _createVNode(_component_el_input_number, {
            modelValue: deliveryConfigInfo.postage,
            "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => deliveryConfigInfo.postage = $event),
            min: 0,
            max: 99999.99,
            precision: 2,
            class: "ml"
          }, null, 8, ["modelValue", "max"]), _hoisted_37])) : _createCommentVNode("", true)])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "运输保险"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_radio_group, {
            modelValue: deliveryConfigInfo.deliveryInsuranceStatus,
            "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => deliveryConfigInfo.deliveryInsuranceStatus = $event)
          }, {
            default: _withCtx(() => [_createVNode(_component_el_radio, {
              label: 0
            }, {
              default: _withCtx(() => [_hoisted_38]),
              _: 1
            }), _createVNode(_component_el_radio, {
              label: 1
            }, {
              default: _withCtx(() => [_hoisted_39]),
              _: 1
            }), _createVNode(_component_el_radio, {
              label: 2
            }, {
              default: _withCtx(() => [_hoisted_40]),
              _: 1
            })]),
            _: 1
          }, 8, ["modelValue"]), deliveryConfigInfo.deliveryInsuranceStatus === 1 ? (_openBlock(), _createElementBlock("div", _hoisted_41, [_createVNode(_component_el_input, {
            modelValue: deliveryConfigInfo.noMinPremiumDesc,
            "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => deliveryConfigInfo.noMinPremiumDesc = $event),
            placeholder: "备注说明保额比例（例：1元即1000保额）",
            style: {
              "width": "400px"
            }
          }, null, 8, ["modelValue"])])) : _createCommentVNode("", true), deliveryConfigInfo.deliveryInsuranceStatus === 2 ? (_openBlock(), _createElementBlock("div", _hoisted_42, [_hoisted_43, _createVNode(_component_el_input_number, {
            modelValue: deliveryConfigInfo.minPremiumAmount,
            "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => deliveryConfigInfo.minPremiumAmount = $event),
            min: 0,
            max: 99999.99,
            precision: 2,
            style: {
              "margin": "0 8px"
            }
          }, null, 8, ["modelValue", "max"]), _createVNode(_component_el_input, {
            modelValue: deliveryConfigInfo.hasMinPremiumDesc,
            "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => deliveryConfigInfo.hasMinPremiumDesc = $event),
            placeholder: "备注说明保额比例（例：1元即1000保额）",
            style: {
              "width": "400px",
              "margin-left": "8px"
            }
          }, null, 8, ["modelValue"])])) : _createCommentVNode("", true)]),
          _: 1
        }), _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            type: "primary",
            style: {
              "margin-left": "68px"
            },
            onClick: save
          }, {
            default: _withCtx(() => [_hoisted_44]),
            _: 1
          })]),
          _: 1
        })])])]),
        _: 1
      })) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _unref(basicShow) ? (_openBlock(), _createElementBlock("div", _hoisted_45, [_createElementVNode("div", _hoisted_46, [_hoisted_47, _hoisted_48, _createVNode(_component_el_switch, {
        modelValue: chooseKpType.value,
        "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => chooseKpType.value = $event),
        "active-value": 1,
        "inactive-value": 0,
        onChange: chooseKpTypeSwitchHandle
      }, null, 8, ["modelValue"])])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_49, [_hoisted_50, _createVNode(_component_el_form, null, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "关联货主"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: branchStorageData.branchOwnerInfoVos,
            multiple: "",
            filterable: "",
            remote: "",
            remoteShowSuffix: "",
            remoteMethod: branchStorageSearchHandle,
            loading: selectLoading.value,
            "value-key": "ownerId",
            onChange: branchChangeHandle,
            onRemoveTag: branchRemoveHandle,
            style: {
              "width": "700px"
            },
            class: "remote-select",
            placeholder: "请输入选择货主"
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(branchList.value, item => {
              return _openBlock(), _createBlock(_component_el_option, {
                label: getOwnerName(item),
                value: item,
                key: item.ownerId
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue", "loading"])]),
          _: 1
        }), _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            type: "primary",
            style: {
              "margin-left": "68px"
            },
            onClick: branchStorageSaveHandle
          }, {
            default: _withCtx(() => [_hoisted_51]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      })]), !loading.value && _unref(userType) === 2 ? (_openBlock(), _createElementBlock("div", _hoisted_52, [_createVNode(PanelWrapper, {
        title: "关联货主"
      }, {
        default: _withCtx(() => [_createVNode(_component_vxe_grid, _mergeProps({
          "row-id": "supplierOwnerId",
          "checkbox-config": {
            reserve: true,
            showHeader: false
          },
          ref_key: "ownerTable",
          ref: ownerTable,
          "pager-config": tablePage
        }, _unref(ownerTableOptions), {
          onCheckboxChange: handleCheckboxChange,
          onCheckboxAll: handleAllCheckboxChange
        }), {
          tools: _withCtx(() => [_createVNode(_component_el_button, {
            type: "primary",
            icon: "Plus",
            onClick: addOwnerModal
          }, {
            default: _withCtx(() => [_hoisted_53]),
            _: 1
          })]),
          operation: _withCtx(({
            row
          }) => [_createVNode(_component_el_button, {
            type: "primary",
            onClick: $event => delOwnerRow(row)
          }, {
            default: _withCtx(() => [_hoisted_54]),
            _: 2
          }, 1032, ["onClick"])]),
          _: 1
        }, 16)]),
        _: 1
      }), _createVNode(AddSupplierOwnerModal, {
        modelValue: showAddOwnerModal.value,
        "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => showAddOwnerModal.value = $event),
        dept: __props.actDept,
        supplierId: _unref(route).query.supplierId,
        structureId: !_unref(basicShow) ? props.actDept.id : '',
        onSuccess: loadSupplierOwner
      }, null, 8, ["modelValue", "dept", "supplierId", "structureId"])])) : _createCommentVNode("", true), !loading.value && _unref(userType) === 2 ? (_openBlock(), _createElementBlock("div", _hoisted_55, [_createElementVNode("div", _hoisted_56, [_hoisted_57, _createVNode(_component_el_switch, {
        modelValue: unifiedWarehouseStatus.value,
        "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => unifiedWarehouseStatus.value = $event),
        "active-value": 1,
        "inactive-value": 0,
        onChange: saveUnifiedWarehouseStatus
      }, null, 8, ["modelValue"])])])) : _createCommentVNode("", true), _unref(basicShow) ? (_openBlock(), _createElementBlock("div", _hoisted_58, [_createElementVNode("div", _hoisted_59, [_hoisted_60, _createVNode(_component_el_switch, {
        modelValue: offlineSettlement.value,
        "onUpdate:modelValue": _cache[21] || (_cache[21] = $event => offlineSettlement.value = $event),
        "active-value": 1,
        "inactive-value": 0,
        onChange: saveOfflineSettlement
      }, null, 8, ["modelValue"])])])) : _createCommentVNode("", true), false ? (_openBlock(), _createElementBlock("div", _hoisted_61, [_createElementVNode("div", _hoisted_62, [_hoisted_63, _createVNode(_component_el_switch, {
        modelValue: creditSettlement.value,
        "onUpdate:modelValue": _cache[22] || (_cache[22] = $event => creditSettlement.value = $event),
        "active-value": 1,
        "inactive-value": 0,
        onChange: saveCreditSettlement
      }, null, 8, ["modelValue"])])])) : _createCommentVNode("", true), _unref(basicShow) ? (_openBlock(), _createElementBlock("div", _hoisted_64, [_createElementVNode("div", _hoisted_65, [_hoisted_66, _hoisted_67, _createVNode(_component_el_switch, {
        modelValue: orderCancelStatus.value,
        "onUpdate:modelValue": _cache[23] || (_cache[23] = $event => orderCancelStatus.value = $event),
        "active-value": 1,
        "inactive-value": 0,
        onChange: orderCancelStatusSwitchHandle
      }, null, 8, ["modelValue"])]), _hoisted_68])) : _createCommentVNode("", true), !loading.value && _unref(userType) === 2 ? (_openBlock(), _createElementBlock("div", _hoisted_69, [_createElementVNode("div", _hoisted_70, [_hoisted_71, _createVNode(_component_el_switch, {
        modelValue: dynamicBusinessMenuStatus.value,
        "onUpdate:modelValue": _cache[24] || (_cache[24] = $event => dynamicBusinessMenuStatus.value = $event),
        "active-value": 1,
        "inactive-value": 0,
        onChange: dynamicBusinessMenuStatusSwitchHandle
      }, null, 8, ["modelValue"])])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_72, [_createElementVNode("div", _hoisted_73, [_hoisted_74, _hoisted_75, _createVNode(_component_el_switch, {
        modelValue: overdueCustOrderCheck.value,
        "onUpdate:modelValue": _cache[25] || (_cache[25] = $event => overdueCustOrderCheck.value = $event),
        "active-value": 1,
        "inactive-value": 0,
        onChange: overdueCustOrderCheckSwitchHandle
      }, null, 8, ["modelValue"])]), _hoisted_76]), _createElementVNode("div", _hoisted_77, [_hoisted_78, _createElementVNode("div", _hoisted_79, [_createVNode(_component_el_radio_group, {
        modelValue: logisticsQueryType.value,
        "onUpdate:modelValue": _cache[26] || (_cache[26] = $event => logisticsQueryType.value = $event),
        disabled: _unref(userType) !== 2,
        onChange: saveLogisticsQueryType
      }, {
        default: _withCtx(() => [_createVNode(_component_el_radio, {
          label: 1
        }, {
          default: _withCtx(() => [_hoisted_80]),
          _: 1
        }), _createVNode(_component_el_radio, {
          label: 2
        }, {
          default: _withCtx(() => [_hoisted_81]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue", "disabled"])])]), !loading.value && _unref(userType) === 2 ? (_openBlock(), _createElementBlock("div", _hoisted_82, [_createElementVNode("div", _hoisted_83, [_hoisted_84, _hoisted_85, _createVNode(_component_el_switch, {
        modelValue: cashOnDeliveryStatus.value,
        "onUpdate:modelValue": _cache[27] || (_cache[27] = $event => cashOnDeliveryStatus.value = $event),
        "active-value": 1,
        "inactive-value": 0,
        onChange: cashDeliveryHandle
      }, null, 8, ["modelValue"])]), _hoisted_86])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_87, [_createElementVNode("div", _hoisted_88, [_hoisted_89, _hoisted_90, _createVNode(_component_el_switch, {
        modelValue: prePaymentSwitch.value,
        "onUpdate:modelValue": _cache[28] || (_cache[28] = $event => prePaymentSwitch.value = $event),
        "active-value": 1,
        "inactive-value": 0,
        onChange: prePaymentSwitchHandle
      }, null, 8, ["modelValue"])]), _hoisted_91, _hoisted_92])]);
    };
  }

};